import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';
import jquery from 'jquery';
import * as extra from '../extra';

export default class Prep extends React.Component {

    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.submit = this.submit.bind(this);
        this.getFile = this.getFile.bind(this);
        this.pushFile = this.pushFile.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.preview = this.preview.bind(this);



        this.state = {
            fio: '',
            listFioIsLoaded: false,
            listFio: [],
            input_1: '',
            input_2: '',
            input_3: '',
            input_4: '',
            input_5: '',
            input_6: '',
            input_file: '',
            status: '',
            count_pps: 0 //кол-во заполненных ППС
        };
    };

    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }

    pushFile(file){
      //отправка на сервер
      /*
      console.log('отправляем на сервер:');
      console.log(file.getAll('fio')[0]);
      console.log(file.getAll('input_1')[0]);
      console.log(file.getAll('input_2')[0]);
      console.log(file.getAll('input_3')[0]);
      console.log(file.getAll('input_4')[0]);
      console.log(file.getAll('input_5')[0]);
      console.log(file.getAll('input_6')[0]);
      console.log(file.getAll('file')[0]);
      console.log('_____________________________________________');
      */
      let res = '';
      jquery.ajax({
          type: "POST",
          url: '/api/addFile.php',
          async: false,
          data: file,
          contentType: false,
          processData: false,
          success: function(data) {
              console.log(data);
              res = data;
          },
          error: function(data) {
              console.log(data);
              res = data;
          }
      });
      this.clearForm();
      if(res > -1){
        this.showStatus('Данные успешно добавлены', 10000);
      } else {
        this.showStatus('Ошибка! данные не были добавлены', 10000);
      }
    }

    clearForm(){
      this.setState({
        fio: '',
        input_1: '',
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_6: '',
        input_file: '',
        status: ''
      })
    }

    showStatus(text, time){
      this.setState({
        status: text
      })
      setTimeout(() => {
        this.setState({
          status: ''
        })
      }, time)
    }

    submit(){
      let data = {
        fio: this.state.fio,
        input_1: this.state.input_1,
        input_2: this.state.input_2,
        input_3: this.state.input_3,
        input_4: this.state.input_4,
        input_5: this.state.input_5,
        input_6: this.state.input_6,
        input_file: this.state.input_file
      }

      if( (data.input_file !== '') && (data.input_file !== undefined) ){
        let formdata = new FormData();
        formdata.append('file', data.input_file);
        formdata.append('fio', data.fio);
        formdata.append('input_1', data.input_1);
        formdata.append('input_2', data.input_2);
        formdata.append('input_3', data.input_3);
        formdata.append('input_4', data.input_4);
        formdata.append('input_5', data.input_5);
        formdata.append('input_6', data.input_6);
        this.pushFile(formdata);
      } else {
        let res = extra.api('pushPrepToServer', data);
        console.log(res);
        this.clearForm();
        if(res > -1){
          this.showStatus('Данные успешно добавлены', 10000);
        } else {
          this.showStatus('Ошибка! данные не были добавлены', 10000);
        }
      }
    }

    getFile(e){
      this.setState({
        input_file: e.target.files[0]
      })
    }

    preview(){
      let fio = this.state.fio;
      if(fio !== ''){
        //window.location.href = "//pps.istu.ru/api/card.php?fio="+fio;
        window.location.href = "//pps.istu.ru/api/preview.php?fio="+fio;
      } else {
        alert('Заполните ФИО');
        //this.showStatus('Заполните ФИО', 3000);
      }
    }

    componentWillMount(){
      //получение списка ФИО
      let list = extra.api('getListFio', '');
      list = JSON.parse(list);
      list.pop();
      //let list= ['dsfdsf','dsfdsf','dsfdsf','dsfsdf'];

      let count_pps = extra.api('getCountPps', ''); //parseInt

      this.setState({
          listFioIsLoaded: true,
          listFio: list,
          count_pps: count_pps
      });
    }

    render() {
        if( this.props.role == 'prep' ){
            return (
            <div className='prep'>
                <div className='prep-title'>Форму необходимо заполнить до 09.02.2018, данные заполняются за 2017г</div>
                <div className='count-pps'>Всего заполнено: {this.state.count_pps}</div>
                <div className='fio-block'>
                <div className='title'>ФИО ППС</div>
                <Autocomplete
                    items={this.state.listFio}
                    shouldItemRender={(item, value) => item.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item}
                    renderItem={(item, highlighted) =>
                      <div
                        key={item.id}
                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                      >
                        {item}
                      </div>
                    }
                    value={this.state.fio}
                    onChange={e => this.setState({ fio: e.target.value })}
                    onSelect={value => this.setState({ fio: value })}
                />
                <div className='preview-button' onClick={this.preview}>предпросмотр и печать</div>
                </div>

                <div className='input-1-block'>
                <div className='title'>
                  1) Личные и командные призовые места на национальных и международных олимпиадах, соревнованиях, в конкурсах:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_1: e.target.value })}
                        value={this.state.input_1}
                        type='text'
                    />
                </div>

                <div className='input-2-block'>
                <div className='title'>
                  2) Руководство студентами, завоевавшими командные и личные призовые места на национальных и международных олимпиадах, соревнованиях, в конкурсах и пр.:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_2: e.target.value })}
                        value={this.state.input_2}
                        type='text'
                    />
                </div>

                <div className='input-3-block'>
                <div className='title'>
                  3) Организация профориентационных мероприятий:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_3: e.target.value })}
                        value={this.state.input_3}
                        type='text'
                    />
                </div>

                <div className='input-4-block'>
                <div className='title'>
                  4) Организация научных конференций и семинаров, включая студенческие:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_4: e.target.value })}
                        value={this.state.input_4}
                        type='text'
                    />
                </div>

                <div className='input-5-block'>
                <div className='title'>
                  5) Рецензирование научных работ и подготовка отзывов ведущей организации:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_5: e.target.value })}
                        value={this.state.input_5}
                        type='text'
                    />
                </div>

                <div className='input-6-block'>
                <div className='title'>
                  6) Выполнение порученной работы, связанной с обеспечением рабочего процесса или уставной деятельностью:
                </div>
                    <textarea
                        onChange={e => this.setState({ input_6: e.target.value })}
                        value={this.state.input_6}
                        type='text'
                    />
                </div>

                <div className='input-7-block'>
                <div className='title'>
                  *Прикрепите подтверждающие документы (до 60МБ)
                </div>
                    <input type="file" onChange={this.getFile}/>
                </div>

                <div className='status-block'>{this.state.status}</div>

                <div className='submit-button' onClick={this.submit}>Отправить</div>

            </div>
            );
        } else {
            history.push('/auth');
            return ('');
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/Prep.js